export const ReportConfiguration = [
  {
    id: 8,
    name: "Alerts Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.tmp", "tag.tmo", "lora.tmp", "lora.nanotag"],
  },
  {
    id: 3,
    name: "Electricity Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.rhe", "tag.opt", "tag.eastron"],
  },
  {
    id: 6,
    name: "Gas Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["stron.gas"],
  },
  {
    id: 4,
    name: "Hourly Usage Report",
    classSelect: true,
    singleSelect: true,
    multiSelect: false,
    dateRange: true,
    models: [
      "tag.rhw",
      "tag.h2o",
      "tag.wmd",
      "tag.rhe",
      "tag.opt",
      "stron.gas",
    ],
  },
  {
    id: 7,
    name: "Incident Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.tmp", "tag.tmo", "lora.tmp", "lora.nanotag"],
  },
  {
    id: 1,
    name: "Raw Report",
    classSelect: true,
    singleSelect: true,
    multiSelect: false,
    dateRange: true,
    models: undefined,
  },
  {
    id: 9,
    name: "Uptime Extended Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.tmp", "tag.tmo", "lora.tmp", "lora.nanotag"],
  },
  {
    id: 5,
    name: "Uptime Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: [
      "tag.rhw",
      "tag.h2o",
      "tag.wmd",
      "tag.rhe",
      "tag.opt",
      "lora.gateway",
      "stron.gas",
      "tag.tmp",
      "tag.tmo",
      "lora.tmp",
      "lora.nanotag",
    ],
  },
  {
    id: 2,
    name: "Water Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.rhw", "tag.h2o", "tag.wmd"],
  },
];
